import "animate.css/animate.min.css";
import React, { useEffect } from "react";
import { AnimationOnScroll } from "react-animation-on-scroll";
import { Link } from "react-router-dom";
import analytics from "../assets/analytics.png";
import chain from "../assets/chain.png";
import chart from "../assets/chart.png";
import hot from "../assets/hot.png";
import kyc from "../assets/kyc.png";
import percentage from "../assets/percent.svg";
import risk from "../assets/risk.svg";
import shield from "../assets/shield.png";
import sign from "../assets/sign.svg";
import signup from "../assets/signup.png";
import stack from "../assets/stack.png";
import volatile from "../assets/volatile.png";
import LeaderboardTable from "../components/LeaderBoard";
import Loader from "../components/Loader";
import Navbar from "../components/Navbar";
import NumbersTimeline from "../components/NumbersTimeline";
import StrategyFAQ from "../components/StrategyFAQ";
import Footer from "../components/navigation/Footer";
// import fixedYield from "../assets/fixed-yield-mobile.png";
import { useLocation } from "react-router-dom";
import deposit from "../assets/deposit.png";
import trades from "../assets/trades.png";
import Livechat from "../components/LiveChat";
import { SEO } from "../components/SEO";
import Circles from "../components/marquee/Circles";

const Strategies = () => {
  const { pathname, hash, key } = useLocation();

  useEffect(() => {
    // if not a hash link, scroll to top
    if (hash === "") {
      window.scrollTo(0, 0);
    }
    // else scroll to id
    else {
      setTimeout(() => {
        const id = hash.replace("#", "");
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView();
        }
      }, 0);
    }
  }, [pathname, hash, key]); // do this on route change
  return (
    <>
      <SEO
        canonical="/strategies"
        title="Algoo Strategies - Our strategies"
        description="Algoo Strategies offers this algorithmic trading strategy and
                other asset management tools through a decentralized
                organization, as all their projects run on the ERC-20
                block-chain."
      />
      <div>
        <div className="bg-[#0a0c0f]">
          <div>
            <Livechat />
          </div>
          <div>
            <Loader />
          </div>
          <Navbar />
          <div className="pt-32 md:pt-52">
            <div class="relative snap-y snap-mandatory overflow-y-auto scroll-smooth">
              <div class="group w-full snap-start">
                <div>
                  <div class="overflow-hidden">
                    <div class="group-hover/wrap:translate-y-full group-only:animate-reveal group-only:animation-delay-[4000ms]">
                      <div className="w-full text-center text-gray-500">
                        <h1 className="text-[12em] md:text-[20em] text-gray-400 0font-semibold">
                          High Roi
                        </h1>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="min-h-screen justify-center items-center flex">
            <AnimationOnScroll
              animateIn="animate__zoomIn"
              duration={3}
              className="mx-auto"
            >
              <h1 className="text-gray-500 text-3xl leading-[42px] md:text-6xl md:leading-[72px] font-medium max-w-[90%] md:max-w-[70%] w-full mx-auto text-center">
                Begin building wealth by harnessing the power of{" "}
                <span className="text-white">DeFi protocols</span> through the
                algorithmic infrastructure of{" "}
                <span className="text-white">Algoo Strategies' platform</span>
              </h1>
            </AnimationOnScroll>
          </div>
          <div className="min-h-screen bg-[#b2ffce] text-gray-800 justify-center items-center flex py-20 md:py-0">
            <div className="max-w-[90%] md:max-w-[70%] w-full mx-auto">
              <AnimationOnScroll animateIn="animate__fadeIn" duration={2}>
                <h1 className="text-4xl leading-[48px] md:text-6xl md:leading-[72px] font-medium">
                  CeDeFi Strategies <br /> by the Numbers
                </h1>
              </AnimationOnScroll>
              <div className="mt-14 md:mt-20">
                <NumbersTimeline />
              </div>
            </div>
          </div>
          <div className="px-5 md:px-10 lg:px-32 my-28">
            <div className="md:grid grid-cols-2 gap-14 mb-48">
              <AnimationOnScroll animateIn="animate__fadeIn">
                <h1 className="font-medium mb-10 md:mb-0 text-[42px] leading-[50px] text-transparent bg-clip-text bg-gradient-to-r from-purple-200 via-[#b2ffce] to-purple-200 mt-16">
                  What are CeDefi Strategies?
                </h1>
              </AnimationOnScroll>
              <AnimationOnScroll
                animateIn="animate__fadeIn"
                className="space-y-6"
              >
                <div className="flex space-x-5 items-center">
                  <img src={sign} alt="CeDeFi" />
                  <div>
                    <p className="text-gray-400 tex-xl">
                      A combination of DeFi strategies with algorithmic tools.
                    </p>
                  </div>
                </div>
                <div className="flex space-x-5 items-center">
                  <img src={risk} alt="CeDeFi" />
                  <div>
                    <p className="text-gray-400 tex-xl">
                      Tokenized long and short positions on lending markets to
                      balance portfolio risk.
                    </p>
                  </div>
                </div>
                <div className="flex space-x-5 items-center">
                  <img src={percentage} alt="CeDeFi" />
                  <div>
                    <p className="text-gray-400 tex-xl">
                      Automated investment yield products gathering protocol
                      fees while managing liquidity.
                    </p>
                  </div>
                </div>
              </AnimationOnScroll>
            </div>
            <div>
              <AnimationOnScroll animateIn="animate__fadeIn">
                <h1 className="font-medium text-[42px] leading-[50px] text-transparent bg-clip-text bg-gradient-to-r from-purple-200 via-[#b2ffce] to-purple-200 text-center mb-16">
                  CeDefi Strategies in basic terms.
                </h1>
              </AnimationOnScroll>
              <AnimationOnScroll
                animateIn="animate__fadeIn"
                className="md:grid space-y-5 md:space-y-0 grid-cols-3 gap-20 lg:px-20 mb-44"
              >
                <div>
                  <p className="text-[#7a7a7a] opacity-20 font-black text-[150px] text-center">
                    01
                  </p>
                  <p className="text-gray-300 -mt-24 font-medium text-center text-2xl">
                    Enter and exit any strategy at any time based on your vision
                    and risk profile.
                  </p>
                </div>
                <div>
                  <p className="text-[#7a7a7a] opacity-20 font-black text-[150px] text-center">
                    02
                  </p>
                  <p className="text-gray-300 -mt-24 font-medium text-center text-2xl">
                    Manage the portfolio in one place adapting it to market
                    conditions
                  </p>
                </div>
                <div>
                  <p className="text-[#7a7a7a] opacity-20 font-black text-[150px] text-center">
                    03
                  </p>
                  <p className="text-gray-300 -mt-24 font-medium text-center text-2xl">
                    Risks are split into tranches, more risk - more yield
                  </p>
                </div>
              </AnimationOnScroll>
            </div>
            <div className="md:my-40 my-20">
              <AnimationOnScroll animateIn="animate__fadeIn">
                <h1 className="text-center font-medium text-4xl text-gray-300">
                  Meet our CeDefi Strategies
                </h1>
                <p className="text-center text-base font-medium text-gray-400 mb-10">
                  We will regularly add new strategies to the platform
                </p>
              </AnimationOnScroll>
              <AnimationOnScroll animateIn="animate__fadeIn">
                <LeaderboardTable />
              </AnimationOnScroll>
            </div>
            <div className="mb-44">
              <AnimationOnScroll animateIn="animate__fadeIn">
                <h1 className="font-medium text-[42px] leading-[50px] text-transparent bg-clip-text bg-gradient-to-r from-purple-200 via-[#b2ffce] to-purple-200 text-center mb-16">
                  Advantages & Risks
                </h1>
              </AnimationOnScroll>

              <div className="relative">
                <div className="md:grid space-y-5 md:space-y-0 grid-cols-2 gap-10 px-0 lg:px-32 mb-12">
                  <div className="bg-[#b2ffce] rounded-md shadow-xl p-5 md:p-10">
                    <h1 className="text-gray-700 font-medium text-3xl mb-8">
                      Advantages
                    </h1>
                    <div className="space-y-8">
                      <div className="flex items-center space-x-6">
                        <img src={hot} className="w-12" alt="CeDeFi" />
                        <div>
                          <h2 className="text-gray-600 font-medium text-xl">
                            High Performance
                          </h2>
                          <p className="text-gray-500 tex-xl">
                            High performance in various market cycles following
                            high yields from DeFi protocols.
                          </p>
                        </div>
                      </div>
                      <div className="flex items-center space-x-6">
                        <img src={stack} className="w-12" alt="CeDeFi" />
                        <div>
                          <h2 className="text-gray-600 font-medium text-xl">
                            Simple Interface
                          </h2>
                          <p className="text-gray-500 tex-xl">
                            User-friendly interface that allows investors to
                            easily engage in complex DeFi strategies in just a
                            few clicks.
                          </p>
                        </div>
                      </div>
                      <div className="flex items-center space-x-6">
                        <img src={analytics} className="w-12" alt="CeDeFi" />
                        <div>
                          <h2 className="text-gray-600 font-medium text-xl">
                            Detailed Analytics
                          </h2>
                          <p className="text-gray-500 tex-xl">
                            Transparent, on-chain analytics which shows the
                            performance of each strategy.
                          </p>
                        </div>
                      </div>
                      <div className="flex items-center space-x-6">
                        <img src={shield} className="w-12" alt="CeDeFi" />
                        <div>
                          <h2 className="text-gray-600 font-medium text-xl">
                            High Liquidity
                          </h2>
                          <p className="text-gray-500 tex-xl">
                            Liquid positions which allow investors to enter and
                            exit these strategies 24/7.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="bg-[#181b20] rounded-md shadow-xl p-5 md:p-10">
                    <h1 className="text-gray-400 font-medium text-3xl mb-8">
                      Risks
                    </h1>
                    <div className="space-y-8">
                      <div className="flex items-center space-x-6">
                        <img src={volatile} className="w-12" alt="CeDeFi" />
                        <div>
                          <h2 className="text-gray-400 font-medium text-xl">
                            Market movement
                          </h2>
                          <p className="text-gray-300 tex-xl">
                            Market trends which perform counter to the original
                            concept of the strategy (which may result in price
                            depreciation and some level of loss of original
                            capital investment).
                          </p>
                        </div>
                      </div>
                      <div className="flex items-center space-x-6">
                        <img src={chart} className="w-12" alt="CeDeFi" />
                        <div>
                          <h2 className="text-gray-400 font-medium text-xl">
                            High Volatility
                          </h2>
                          <p className="text-gray-300 tex-xl">
                            High volatility in the market may lead to
                            impermanent loss.
                          </p>
                        </div>
                      </div>
                      <div className="flex items-center space-x-6">
                        <img src={chain} className="w-12" alt="CeDeFi" />
                        <div>
                          <h2 className="text-gray-400 font-medium text-xl">
                            It's still DeFi ツ
                          </h2>
                          <p className="text-gray-300 tex-xl">
                            Systematic DeFi risks associated with the
                            vulnerability of protocols and smart contracts.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="mt-20">
                  <h1 className="bg-[#0a0c0f] text-gray-300 text-lg md:text-2xl rounded-full absolute m-auto top-0 bottom-0 right-0 left-0 p-1 md:p-2 w-[50px] h-[50px] md:w-[85px] md:h-[85px] text-center items-center flex justify-center">
                    VS
                  </h1>
                </div>
              </div>
              <a
                className="w-[350px] py-3 px-4 space-x-3 flex duration-500 hover:bg-gray-200 items-center mx-auto justify-center bg-white text-gray-600 rounded-md"
                href="https://wiki.algoostrategies.org/algoo-strategies-wiki/"
              >
                <svg
                  width="25"
                  viewBox="0 0 25 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M22.5 1.25H22.4462C20.269 1.24998 18.5461 1.24997 16.9538 1.52912C15.4454 1.79359 14.0689 2.30412 12.5 3.25821C10.9311 2.30412 9.55461 1.79359 8.04619 1.52913C6.45395 1.24997 4.73099 1.24998 2.55379 1.25H2.55378H2.5C2.30109 1.25 2.11032 1.32902 1.96967 1.46967C1.82902 1.61032 1.75 1.80109 1.75 2V12.6571L1.75 12.6866V12.6866C1.74999 13.2123 1.74999 13.6501 1.77802 14.0072C1.80718 14.3786 1.87018 14.728 2.03293 15.0585C2.28743 15.5753 2.66945 15.9751 3.17415 16.2528C3.50137 16.4329 3.8604 16.5109 4.24223 16.5568C4.61389 16.6016 5.07637 16.6226 5.63741 16.6482L5.66613 16.6495C8.09527 16.76 9.79896 17.1552 12.0944 18.6309C12.3415 18.7897 12.6585 18.7897 12.9056 18.6309C15.201 17.1552 16.9047 16.76 19.3339 16.6495L19.3626 16.6482C19.9236 16.6226 20.3861 16.6016 20.7578 16.5568C21.1396 16.5109 21.4986 16.4329 21.8258 16.2528C22.3306 15.9751 22.7126 15.5753 22.9671 15.0585C23.1298 14.728 23.1928 14.3786 23.222 14.0072C23.25 13.6501 23.25 13.2123 23.25 12.6866V12.6571V2C23.25 1.58579 22.9142 1.25 22.5 1.25ZM7.78715 3.00659C9.10209 3.23713 10.3118 3.67896 11.75 4.55773V16.6851C9.71804 15.5917 7.96482 15.2526 5.73434 15.151C5.13738 15.1239 4.73108 15.1049 4.42157 15.0676C4.11591 15.0308 3.97818 14.9832 3.89734 14.9387C3.66199 14.8092 3.49728 14.6368 3.3786 14.3958C3.33559 14.3084 3.2957 14.1736 3.27342 13.8898C3.25054 13.5984 3.25 13.2198 3.25 12.6571V2.75048C5.1075 2.75388 6.50403 2.78163 7.78715 3.00659ZM19.2657 15.151C17.0352 15.2526 15.282 15.5917 13.25 16.6851V4.55773C14.6882 3.67896 15.8979 3.23713 17.2129 3.00659C18.496 2.78163 19.8925 2.75388 21.75 2.75048V12.6571C21.75 13.2198 21.7495 13.5984 21.7266 13.8898C21.7043 14.1736 21.6644 14.3084 21.6214 14.3958C21.5027 14.6368 21.338 14.8092 21.1027 14.9387C21.0218 14.9832 20.8841 15.0308 20.5784 15.0676C20.2689 15.1049 19.8626 15.1239 19.2657 15.151ZM3.5 18.75C3.08579 18.75 2.75 19.0858 2.75 19.5C2.75 19.9142 3.08579 20.25 3.5 20.25C5.47377 20.25 6.89687 20.3743 8.17766 20.7236C9.45056 21.0707 10.6262 21.6522 12.084 22.624C12.3359 22.792 12.6641 22.792 12.916 22.624C14.3738 21.6522 15.5494 21.0707 16.8223 20.7236C18.1031 20.3743 19.5262 20.25 21.5 20.25C21.9142 20.25 22.25 19.9142 22.25 19.5C22.25 19.0858 21.9142 18.75 21.5 18.75C19.4738 18.75 17.8969 18.8757 16.4277 19.2764C15.085 19.6426 13.8686 20.2283 12.5 21.1041C11.1314 20.2283 9.91499 19.6426 8.57234 19.2764C7.10313 18.8757 5.52624 18.75 3.5 18.75Z"
                    fill="#0A0C0F"
                  ></path>
                </svg>
                <h1 className="font-medium">Learn more on Algoo's Wiki</h1>
              </a>
            </div>

            <div>
              <AnimationOnScroll
                animateIn="animate__fadeIn"
                className="max-w-[90%] lg:max-w-[60%] mx-auto text-center"
              >
                <h1 className="font-medium text-3xl md:text-[42px] md:leading-[50px] text-transparent bg-clip-text bg-gradient-to-r from-purple-200 via-[#b2ffce] to-purple-200 mb-4 mt-10">
                  Four simple steps to begin trading DeFi on Algoo Strategies'
                  platform
                </h1>
              </AnimationOnScroll>
              <div className="max-w-[90%] mx-auto mt-10">
                <AnimationOnScroll animateIn="animate__fadeIn">
                  <div className="md:flex items-center md:space-x-10 lg:space-x-20 my-20">
                    <div className="w-[70%] max-md:hidden">
                      <img className="w-full rotate-45" src={signup} alt="" />
                    </div>
                    <div className="w-full">
                      <div className="bg-gradient-to-r from-purple-200 via-[#b2ffce] to-purple-200 py-2 w-full text-center rounded-full mb-2 max-w-[100px]">
                        <p className="font-medium text-sm">Step 1</p>
                      </div>
                      <h1 className="text-gray-300 mb-2 text-3xl font-medium">
                        Create an account
                      </h1>
                      <p className="font-medium text-gray-400">
                        Sign up on Algoo Strategies' platform using your email
                      </p>
                    </div>
                  </div>
                </AnimationOnScroll>
                <AnimationOnScroll animateIn="animate__fadeIn">
                  <div className="md:flex items-center md:space-x-10 lg:space-x-20 my-20">
                    <div className="w-full">
                      <div className="bg-gradient-to-r from-purple-200 via-[#b2ffce] to-purple-200 py-2 w-full text-center rounded-full mb-2 max-w-[100px]">
                        <p className="font-medium text-sm">Step 2</p>
                      </div>
                      <h1 className="text-gray-300 mb-2 text-3xl font-medium">
                        Verify your identity
                      </h1>
                      <p className="font-medium text-gray-400">
                        Verify your identity by providing us with the requested
                        information. Your verification will be processed over
                        the following 2 working days.
                      </p>
                    </div>
                    <div className="w-[70%] max-md:hidden">
                      <img className="w-[60%]" src={kyc} alt="" />
                    </div>
                  </div>
                </AnimationOnScroll>
                <AnimationOnScroll animateIn="animate__fadeIn">
                  <div className="md:flex items-center md:space-x-10 lg:space-x-20 my-20">
                    <div className="w-[70%] max-md:hidden">
                      <img className="w-[50%]" src={deposit} alt="" />
                    </div>
                    <div className="w-full">
                      <div className="bg-gradient-to-r from-purple-200 via-[#b2ffce] to-purple-200 py-2 w-full text-center rounded-full mb-2 max-w-[100px]">
                        <p className="font-medium text-sm">Step 3</p>
                      </div>
                      <h1 className="text-gray-300 mb-2 text-3xl font-medium">
                        Make a deposit
                      </h1>
                      <p className="font-medium text-gray-400">
                        Deposit any supported crypto on Algoo Strategies’
                        platform
                      </p>
                    </div>
                  </div>
                </AnimationOnScroll>
                <AnimationOnScroll animateIn="animate__fadeIn">
                  <div className="md:flex items-center md:space-x-10 lg:space-x-20 my-20">
                    <div className="w-full">
                      <div className="bg-gradient-to-r from-purple-200 via-[#b2ffce] to-purple-200 py-2 w-full text-center rounded-full mb-2 max-w-[100px]">
                        <p className="font-medium text-sm">Step 4</p>
                      </div>
                      <h1 className="text-gray-300 mb-2 text-3xl font-medium">
                        Trade Strategies
                      </h1>
                      <p className="font-medium text-gray-400">
                        Trade different available strategies or stake yield
                        assets.
                      </p>
                    </div>
                    <div className="w-[70%] max-md:hidden">
                      <img className="w-full" src={trades} alt="" />
                    </div>
                  </div>
                </AnimationOnScroll>
              </div>
            </div>
          </div>
          <img
            src="https://uploads-ssl.webflow.com/62fb765fc0871b025cda9b9d/6329f470e9dd74208bdece05_Frame%2041230.png"
            srcset="https://uploads-ssl.webflow.com/62fb765fc0871b025cda9b9d/6329f470e9dd74208bdece05_Frame%252041230-p-500.png 500w, https://uploads-ssl.webflow.com/62fb765fc0871b025cda9b9d/6329f470e9dd74208bdece05_Frame%252041230-p-800.png 800w, https://uploads-ssl.webflow.com/62fb765fc0871b025cda9b9d/6329f470e9dd74208bdece05_Frame%252041230-p-1080.png 1080w, https://uploads-ssl.webflow.com/62fb765fc0871b025cda9b9d/6329f470e9dd74208bdece05_Frame%252041230-p-1600.png 1600w, https://uploads-ssl.webflow.com/62fb765fc0871b025cda9b9d/6329f470e9dd74208bdece05_Frame%252041230-p-2000.png 2000w, https://uploads-ssl.webflow.com/62fb765fc0871b025cda9b9d/6329f470e9dd74208bdece05_Frame%252041230-p-2600.png 2600w, https://uploads-ssl.webflow.com/62fb765fc0871b025cda9b9d/6329f470e9dd74208bdece05_Frame%252041230-p-3200.png 3200w"
            sizes="(max-width: 1919px) 100vw, 3190px"
            alt=""
            class="image-93"
          ></img>
          <div
            id="fixedYield"
            className="relative bg-gradient-to-b from-[#181b20] to-[#0a0c0f] py-10 mt-0 text-center"
          >
            <div className="mx-auto md:max-w-[50%] text-white">
              <p className="md:font-medium text-gray-400 text-lg mb-5 max-lg:mx-4">
                If you’d prefer to earn a stable, fixed yield on your digital
                assets, there are more than 15 assets with fixed yields
                available on Algoo Strategies' platform
              </p>
              <h1 className="font-medium text-3xl md:text-4xl lg:text-7xl leading-loosed text-transparent bg-clip-text bg-gradient-to-r from-purple-200 via-[#b2ffce] to-purple-200 mb-4 mt-10">
                Earn a Fixed Yield on Your Crypto Assets
              </h1>
              <Link to="/coming-soon" className="">
                <button className="text-gray-800 duration-500 bg-[#b2ffce] mt-4 max-md:w-60 max-md:mx-auto py-2 px-5 rounded-xl">
                  <p className="text-center font-medium">
                    Invest in core assets
                  </p>
                </button>
              </Link>
            </div>
            <div className="mt-12">
              <Circles />
            </div>
          </div>

          <div className="md:grid grid-cols-2 gap-24 px-5 md:px-10 lg:px-32 ">
            <div>
              <AnimationOnScroll animateIn="animate__fadeIn">
                <h1 className="font-medium text-[42px] leading-[50px] text-transparent bg-clip-text bg-gradient-to-r from-purple-200 via-[#b2ffce] to-purple-200 mb-4 mt-10">
                  Frequently Asked Questions about our strategies
                </h1>
              </AnimationOnScroll>

              <p className="text-gray-400 mb-10 md:mb-0">
                Can’t find the answer you’re looking for? Feel free to contact
                us directly via our{" "}
                <Link to="/contact" className="text-[#b2ffce] underline">
                  contact
                </Link>{" "}
                page
              </p>
            </div>
            <AnimationOnScroll animateIn="animate__fadeIn">
              <StrategyFAQ />
            </AnimationOnScroll>
          </div>
          <AnimationOnScroll
            animateIn="animate__fadeIn"
            className="px-5 sm:px-10 md:px-20 lg:px-32 mt-14"
          >
            <Footer />
          </AnimationOnScroll>
        </div>
      </div>
    </>
  );
};

export default Strategies;
